import { Trans } from '@lingui/react/macro'

import { H2 } from '../../../../_components/H2'
import { PrimaryButton } from '../../../../_components/PrimaryButton'

import type { IReviewProps } from '../../../_types/review'

import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'

export const ReviewCta: React.FC<{
  cta: IReviewProps['cta']
}> = ({ cta }) => {
  if (!cta) {
    return null
  }
  return (
    <div className='relative z-[1] mx-auto max-w-[912px] px-4 pb-12 pt-14 text-center md:pb-[120px] md:pt-[160px]'>
      <span
        style={{
          background:
            'linear-gradient(360deg, rgba(201, 175, 255, 0.2) 0%, rgba(121, 105, 153, 0.2) 100%)',
        }}
        className='text-f-other-9 mx-auto block w-fit rounded-full border border-[#C9AFFF33] px-5 py-1.5 text-xs md:text-sm'
      >
        <Trans>Tad.ai</Trans>
      </span>
      <H2 className='pb-3 pt-6 md:text-7xl'>{cta.title}</H2>
      <RichTextElement
        as='p'
        html={cta.desc}
        className='text-f-other-10 text-sm md:text-base'
      />
      <PrimaryButton
        href='/ai-music-generator'
        className='mx-auto mt-4 md:mt-8'
      >
        {cta.btnText}
      </PrimaryButton>
    </div>
  )
}
